import React from 'react';
import {CssVariant} from "../config/FusionConfig";

const VariantLabel = React.memo(({
                                     className = "",
                                     variant = CssVariant.primary,
                                     roundedVariant = 5,
                                     height = '16px',
                                     position = '',
                                     style = {},
                                     px = '',
                                     py = '',
                                     padding = '.3rem .4rem',
                                     top = '',
                                     right = '',
                                     bottom = '',
                                     left = '',
                                     children,
                                     ...rest
                                 }) => {
    return (<>
            <label
                className={`m-0 text-nowrap fs-sm rounded-${roundedVariant} d-flex jc-center al-center flex-nowrap px-${px} py-${py} bg-${variant} position-${position} ${className}`}
                style={{
                    color: getTextColor(),
                    padding: padding,
                    height: height,
                    top, right, bottom, left,
                    // top:top,
                    // right:right,
                    // bottom:right,
                    // left:left,
                    ...style
                }}
                {...rest}
            >
                {children}
            </label>
        </>
    );

    function getTextColor() {
        switch (variant) {
            case CssVariant.primary:
                return '#e2f2fd';
            case CssVariant.success:
                return '#f0fdee';
            case CssVariant.warning:
                return '#000000';
            case CssVariant.info:
                return '#000000';
            case 'error':
            case CssVariant.danger:
                return '#faf2f2';
            default :
                return '#000000';
        }
    }
});
export default VariantLabel;
